export default ".grid {\n  display: grid;\n  align-items: center;\n  justify-content: left;\n  padding: 3px;\n  grid-auto-flow: column;\n  grid-gap: 5px;\n}";